import { useSettingsContext } from "../hook/useSettingsContext";
import { useStyleBuilder } from "../hook/useStyleBuilder";
import { useSpacingValue } from "../hook/useSpacingValue";

export const customStyleVariables = () => {
    const { getOption } = useSettingsContext();

    return useStyleBuilder({
        "--wpb-quantity-width": getOption("qtyWidth", "input"),
        "--wpb-quantity-height": getOption("qtyHeight", "input"),
        "--wpb-quantity-border-width": getOption("borderWidth", "input"),
        "--wpb-quantity-border-radius": getOption("borderRadius", "input"),
        "--wpb-quantity-border-color": getOption("borderColor", "input"),
        "--wpb-quantity-border-hover-color": getOption(
            "borderHoverColor",
            "input",
        ),
        "--wpb-quantity-input-color": getOption("qtyColor", "input"),
        "--wpb-quantity-input-hover-color": getOption("qtyHoverColor", "input"),
        "--wpb-quantity-bg": getOption("btnBgColor", "input"),
        "--wpb-quantity-hover-bg": getOption("btnBgHoverColor", "input"),
        "--wpb-quantity-font-size": getOption("qtyFontSize", "input"),
        "--wpb-quantity-font-weight": getOption("qtyFontWeight", "input"),
        "--wpb-quantity-padding": useSpacingValue(
            getOption("qtyPadding", "input"),
        ),
        "--wpb-quantity-margin": useSpacingValue(
            getOption("qtyMargin", "input"),
        ),

        "--wpb-quantity-icon-width": getOption("iconAreaWidth", "icon"),
        "--wpb-quantity-icon-height": getOption("iconAreaHeight", "icon"),
        "--wpb-quantity-icon-size": getOption("iconsSize", "icon"),
        "--wpb-quantity-icon-color": getOption("iconColor", "icon"),
        "--wpb-quantity-icon-hover-color": getOption("iconHoverColor", "icon"),
        "--wpb-quantity-icon-bg": getOption("iconBg", "icon"),
        "--wpb-quantity-icon-hover-bg": getOption("iconHoverBg", "icon"),
        "--wpb-quantity-icons-border-width": getOption(
            "iconsBorderWidth",
            "icon",
        ),
        "--wpb-quantity-icons-border-radius": getOption("iconsRadius", "icon"),
        "--wpb-quantity-icons-border-color": getOption(
            "iconsBorderColor",
            "icon",
        ),
        "--wpb-quantity-icons-border-hover-color": getOption(
            "iconsBorderHoverColor",
            "icon",
        ),

        "--wpb-quantity-prefix-font-size": getOption(
            "prefixFontSize",
            "prefixsuffix",
        ),
        "--wpb-quantity-prefix-font-weight": getOption(
            "prefixFontWeight",
            "prefixsuffix",
        ),
        "--wpb-quantity-prefix-align": getOption(
            "prefixAlignment",
            "prefixsuffix",
        ),
        "--wpb-quantity-prefix-margin": useSpacingValue(
            getOption("prefixMargin", "prefixsuffix"),
        ),
        "--wpb-quantity-suffix-margin": useSpacingValue(
            getOption("suffixMargin", "prefixsuffix"),
        ),
        "--wpb-quantity-slider-thumb-size": getOption("thumbSize", "slider"),
        "--wpb-quantity-slider-width": getOption("sliderWidth", "slider"),
        "--wpb-quantity-slider-height": getOption("sliderHeight", "slider"),
        "--wpb-quantity-slider-thumb-bg": getOption("thumbBgColor", "slider"),
        "--wpb-quantity-slider-thumb-color": getOption(
            "thumbTextColor",
            "slider",
        ),
        "--wpb-quantity-slider-track-color": getOption("trackColor", "slider"),
        "--wpb-quantity-slider-input-color": getOption("inputColor", "slider"),
        "--wpb-quantity-slider-thumb-font-size": getOption(
            "thumbFontSize",
            "slider",
        ),
        "--wpb-quantity-slider-thumb-font-weight": getOption(
            "thumbFontWeight",
            "slider",
        ),
        "--wpb-quantity-slider-input-font-size": getOption(
            "inputFontSize",
            "slider",
        ),
        "--wpb-quantity-slider-input-font-weight": getOption(
            "inputFontWeight",
            "slider",
        ),
        "--wpb-quantity-slider-margin": useSpacingValue(
            getOption("sliderMargin", "slider"),
        ),
        "--wpb-quantity-slider-gap": getOption("sliderGap", "slider"),
    });
};
